import { useCallback } from 'react'

import { Dialog, Text } from '@loadsmart/loadsmart-ui'

export type RfpConfirmationDialogProps = {
  title: string
  body: React.ReactNode
  confirmLabel?: string
  cancelLabel?: string
  onConfirm: () => void
  onCancel: () => void
}

export function RfpConfirmationDialog({
  title,
  body,
  onConfirm,
  onCancel,
  confirmLabel = 'Submit',
  cancelLabel = 'Cancel',
}: RfpConfirmationDialogProps) {
  const handleOnConfirm = useCallback(onConfirm, [onConfirm])
  const handleOnCancel = useCallback(onCancel, [onCancel])

  return (
    <Dialog onOverlayClick={handleOnCancel} scale={'small'} open>
      <Dialog.Header>{title}</Dialog.Header>
      <Dialog.Body>
        <Text>{body}</Text>
      </Dialog.Body>
      <Dialog.ActionConfirm onConfirm={handleOnConfirm}>{confirmLabel}</Dialog.ActionConfirm>
      <Dialog.ActionCancel onCancel={handleOnCancel}>{cancelLabel}</Dialog.ActionCancel>
    </Dialog>
  )
}
